module.exports = __webpack_public_path__ + "static/assinatura-bg-0dae17e7fe3fd09b955786d5a2d2aa27.jpg";